import React, { ReactElement, ReactNode } from 'react';
import { FileReportPage, getPageLayout } from '@/features';
import { PageType } from '@/types/page';
import { useAuthRequiredRoute } from '@/hooks';

export default function FileNewReport(): ReactNode {
  useAuthRequiredRoute({
    skip: process.env.NEXT_PUBLIC_REQUIRE_AUTH_TO_REPORT_ENABLED === 'true',
  });
  return <FileReportPage />;
}

FileNewReport.getLayout = (page: ReactElement) =>
  getPageLayout(page, PageType.FILE_REPORT);
